// Node
const $ = require('jquery');
// require('owl.carousel/dist/owl.carousel');
import {tns} from 'tiny-slider/src/tiny-slider';

// Custom
import {
  updateCounterText,
  handleMiniSliderOpen
} from 'new_design/common/sliders';


// const sliderInit = function () {
//   let sightSlider = $('.sight-slider');
//
//   sightSlider.each(function () {
//     let sightSlider = $(this);
//
//     if (sightSlider.hasClass('owl-loaded')) {
//       return;
//     }
//
//     sightSlider.owlCarousel({
//       loop: true,
//       margin: 30,
//       nav: false,
//       dots: false,
//       responsive: {
//         0: {
//           items: 1
//         },
//         992: {
//           items: 4
//         }
//       }
//     });
//
//     let next = $('.sight-slider__next'),
//       prev = $('.sight-slider__prev');
//
//     next.on('click', function () {
//       sightSlider.trigger('next.owl.carousel');
//     });
//     prev.on('click', function () {
//       sightSlider.trigger('prev.owl.carousel', [300]);
//     });
//   });
// };

const popupSliderTnsInit = function () {
  let $sliderWraps = $('.slider-tns__wrap');

  $sliderWraps.each(function () {
    let $wrap = $(this);
    let $slider = $wrap.find('.slider-tns');
    let $controls = $wrap.find('.slider-tns__arrows');
    let $counter = $wrap.find('.slider-tns__counter');
    let $thumbnails = $wrap.find('.slider-tns__thumbnails');
    let lazyloadEnabled = !!$slider.hasClass('slider-tns_lazy');

    if (this.classList.contains('tns-initialised')) return;

    let sliderTns = tns({
      container: $slider[0],
      mode: "gallery",
      items: 1,
      center: true,
      loop: false,
      rewind: true,
      navContainer: $thumbnails[0],
      navAsThumbnails: true,
      controlsContainer: $controls[0],
      arrowKeys: true,
      autoHeight: true,
      lazyload: lazyloadEnabled,
      onInit: (info) => updateCounterText(info, $counter),
    });

    if (!sliderTns) return; // на случай, если изображений нет

    sliderTns.events.on('indexChanged', (info) => updateCounterText(info, $counter));

    $wrap.closest('.popup').on('popupClosed', () => {
      if (sliderTns.getInfo().displayIndex > 1) {
        setTimeout(() => sliderTns.goTo('first'), 500);
      }
    });

    handleMiniSliderOpen($slider, sliderTns);
    this.classList.add('tns-initialised');
  });
};
const campsSliderTnsInit = function () {
  const $sliderWraps = $('.nearby_camps-scroll__wrapper');
  $sliderWraps.each(function () {
    const $wrap = $(this);
    const $slider = $wrap.find('.nearby_camps-scroll');
    const $controls = $wrap.find('.nearby_camps__arrows');
    const $slides = parseInt($slider.attr('data-value'), 10) || 3;
    const $firstSlide = $slider.find('.review-slider-item').first();
    const firstSlideWidth = parseFloat($firstSlide.css('width')) + 2 || 290;
    const reviewSliderLength = $wrap.find('.review-slider').length;

    if (this.classList.contains('camps-tns-initialised')) return;

    const sliderTns = tns({
      container: $slider[0],
      items: $slides,
      slideCountNew: $slides,
      loop: !!reviewSliderLength,
      controlsContainer: $controls[0],
      nav: false,
      fixedWidth: firstSlideWidth,
      rewind: true,
      speed: 400,
      swipeAngle: false,
      preventScrollOnTouch: 'auto'
    });
    sliderTns.events.on('indexChanged', ({ index }) => {
      if (!reviewSliderLength) {
        $controls.find('.nearby_camps_arrow_wrapper-left').toggle(index !== 0);
        $controls.find('.nearby_camps_arrow_wrapper-right').toggle(index < 2);
      }
    });
    if (sliderTns.getInfo().slideCount < 4 && !reviewSliderLength) {
      $controls.find('.nearby_camps_arrow_wrapper-right').hide();
    }

    this.classList.add('camps-tns-initialised');

    const $elemWithLink = $wrap.find('.has-link');
    const link = $elemWithLink.data('link');

    if ($elemWithLink.length && link) {
      const $linkBlock = $elemWithLink.children().last();
      $linkBlock.on('click', function() {
        window.open(link, '_blank').focus();
      });
    }
  });
}
export {
  // sliderInit,
  popupSliderTnsInit,
  campsSliderTnsInit
};
